import React from 'react';

const AuditBackground = () => (
  <div className="fixed inset-0 pointer-events-none" style={{ zIndex: 0, background: '#F8FAFC' }}>
    {/* Geometric SVG Pattern — circuit/tech lines */}
    <svg
      className="absolute inset-0 w-full h-full"
      xmlns="http://www.w3.org/2000/svg"
      style={{ opacity: 1 }}
    >
      <defs>
        <pattern id="techGrid" width="80" height="80" patternUnits="userSpaceOnUse">
          {/* Diamond grid lines */}
          <path d="M0 40 L40 0 L80 40 L40 80 Z" fill="none" stroke="rgba(59,130,246,0.1)" strokeWidth="1" />
          <path d="M40 0 L40 80" fill="none" stroke="rgba(59,130,246,0.06)" strokeWidth="1" />
          <path d="M0 40 L80 40" fill="none" stroke="rgba(59,130,246,0.06)" strokeWidth="1" />
          {/* Corner nodes */}
          <circle cx="40" cy="0" r="2.5" fill="rgba(59,130,246,0.12)" />
          <circle cx="0" cy="40" r="2.5" fill="rgba(59,130,246,0.12)" />
          <circle cx="80" cy="40" r="2.5" fill="rgba(59,130,246,0.12)" />
          <circle cx="40" cy="80" r="2.5" fill="rgba(59,130,246,0.12)" />
          <circle cx="40" cy="40" r="2" fill="rgba(59,130,246,0.08)" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#techGrid)" />
    </svg>

    {/* Glowing Orb — top left */}
    <div
      className="absolute"
      style={{
        top: '-10%',
        left: '-5%',
        width: '60%',
        height: '60%',
        background: 'radial-gradient(circle, rgba(59,130,246,0.05) 0%, transparent 70%)',
        pointerEvents: 'none',
      }}
    />

    {/* Glowing Orb — bottom right */}
    <div
      className="absolute"
      style={{
        bottom: '-10%',
        right: '-5%',
        width: '55%',
        height: '55%',
        background: 'radial-gradient(circle, rgba(147,197,253,0.08) 0%, transparent 60%)',
        pointerEvents: 'none',
      }}
    />

    {/* Subtle center glow */}
    <div
      className="absolute"
      style={{
        top: '30%',
        left: '30%',
        width: '40%',
        height: '40%',
        background: 'radial-gradient(circle, rgba(59,130,246,0.03) 0%, transparent 70%)',
        pointerEvents: 'none',
      }}
    />
  </div>
);

export default AuditBackground;
